import { Box, styled } from '@mui/material';

export const StatusContainer = styled(Box)<{ gap?: string }>(({ gap = '1rem' }) => ({
  display: 'flex',
  alignItems: 'center',
  gap,
  cursor: 'pointer',
  width: 'fit-content',
}));

export const StatusBadge = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',

  '& .status-icon': {
    width: '1.375rem',
    height: '1.375rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '& .status-count': {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.25rem',
  },
}));

export const NotUploadedContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  width: 'fit-content',
}));

export const UploadIconButton = styled(Box)({
  width: '1rem',
  height: '1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#F3F4F6',
  borderRadius: '0.5rem',
  color: '#6B7280',
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: '#E5E7EB',
    transform: 'scale(1.1)',
    color: '#111827',
  },
});

export const ApprovedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      d="M18.5625 11C18.5625 6.82335 15.1767 3.4375 11 3.4375C6.82335 3.4375 3.4375 6.82335 3.4375 11C3.4375 15.1767 6.82335 18.5625 11 18.5625C15.1767 18.5625 18.5625 15.1767 18.5625 11ZM13.3937 8.66536C13.6622 8.39688 14.0974 8.39688 14.3659 8.66536C14.6344 8.93385 14.6344 9.36905 14.3659 9.63753L10.4548 13.5486C10.1863 13.8171 9.75115 13.8171 9.48267 13.5486L8.14974 12.2157C7.88125 11.9472 7.88125 11.512 8.14974 11.2435C8.41823 10.975 8.85342 10.975 9.12191 11.2435L9.96875 12.0903L13.3937 8.66536ZM19.9375 11C19.9375 15.936 15.936 19.9375 11 19.9375C6.06396 19.9375 2.0625 15.936 2.0625 11C2.0625 6.06396 6.06396 2.0625 11 2.0625C15.936 2.0625 19.9375 6.06396 19.9375 11Z"
      fill="#62CB99"
    />
  </svg>
);

export const PendingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      d="M18.7002 11C18.7002 6.82335 15.3143 3.4375 11.1377 3.4375C6.96104 3.4375 3.5752 6.82335 3.5752 11C3.5752 15.1767 6.96104 18.5625 11.1377 18.5625C15.3143 18.5625 18.7002 15.1767 18.7002 11ZM10.4502 7.71916C10.4502 7.33946 10.758 7.03166 11.1377 7.03166C11.5174 7.03166 11.8252 7.33946 11.8252 7.71916V11.5353L14.449 12.4099C14.8092 12.53 15.0041 12.9198 14.884 13.28C14.764 13.6402 14.3741 13.8352 14.0139 13.7151L10.9202 12.6838C10.6394 12.5903 10.4502 12.3272 10.4502 12.0313V7.71916ZM20.0752 11C20.0752 15.936 16.0737 19.9375 11.1377 19.9375C6.20165 19.9375 2.2002 15.936 2.2002 11C2.2002 6.06395 6.20165 2.0625 11.1377 2.0625C16.0737 2.0625 20.0752 6.06395 20.0752 11Z"
      fill="#FFB147"
    />
  </svg>
);

export const RejectedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      d="M18.5625 11C18.5625 6.82335 15.1767 3.4375 11 3.4375C6.82335 3.4375 3.4375 6.82335 3.4375 11C3.4375 15.1767 6.82335 18.5625 11 18.5625C15.1767 18.5625 18.5625 15.1767 18.5625 11ZM13.4304 7.59741C13.6989 7.32893 14.1341 7.32893 14.4026 7.59741C14.6711 7.8659 14.6711 8.30109 14.4026 8.56958L11.9722 11L14.4026 13.4304C14.6711 13.6989 14.6711 14.1341 14.4026 14.4026C14.1341 14.6711 13.6989 14.6711 13.4304 14.4026L11 11.9722L8.56958 14.4026C8.30109 14.6711 7.8659 14.6711 7.59741 14.4026C7.32893 14.1341 7.32893 13.6989 7.59741 13.4304L10.0278 11L7.59741 8.56958C7.32893 8.30109 7.32893 7.8659 7.59741 7.59741C7.8659 7.32893 8.30109 7.32893 8.56958 7.59741L11 10.0278L13.4304 7.59741ZM19.9375 11C19.9375 15.936 15.936 19.9375 11 19.9375C6.06395 19.9375 2.0625 15.936 2.0625 11C2.0625 6.06395 6.06395 2.0625 11 2.0625C15.936 2.0625 19.9375 6.06395 19.9375 11Z"
      fill="#E9554A"
    />
  </svg>
);
